import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/cn';
import { Icon } from '../common/icon';

export interface PartialCashoutButtonProps {
  active?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
}

/** Compact icon-only control that opens the partial cashout slider. */
export function PartialCashoutButton({
  active = false,
  disabled = false,
  onClick,
  className,
}: PartialCashoutButtonProps) {
  const { t } = useTranslation();
  const label = t('PartialCashout', { defaultValue: 'Partial' });

  return (
    <button
      type="button"
      disabled={disabled}
      aria-label={label}
      title={label}
      aria-pressed={active}
      onClick={(event) => {
        event.stopPropagation();
        onClick?.();
      }}
      className={cn(
        'flex h-[52px] w-11 shrink-0 items-center justify-center rounded-md border border-solid',
        disabled
          ? 'cursor-not-allowed border-border-subtle bg-bg-surface text-text-disabled'
          : 'border-status-success bg-bg-surface text-status-success',
        active && !disabled && 'bg-status-success/10',
        className,
      )}
    >
      <Icon
        name="cashout-history"
        size={18}
        className={disabled ? 'text-text-disabled' : 'text-status-success'}
      />
    </button>
  );
}
